import { FC } from "react";
import styled from "styled-components";

import Text from "./Text";
import { ReactComponent as YoutubeIcon } from "@/assets/icons/youtube.svg";
import { AudiencableChannel } from "@/types/resources";

const ChannelCard = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  padding: 16px;
  border: 1px solid ${({ theme }) => theme.colors.grayscaleLight};
  border-radius: 4px;
`;

const ThumbnailWrap = styled.div`
  position: relative;
  width: 36px;
  height: 36px;
  flex-shrink: 0;
  border-radius: 50%;
  border: 1px solid rgba(144, 144, 144, 0.3);
  > svg {
    position: absolute;
    top: -2px;
    left: -2px;
  }
`;

const Thumbnail = styled("img").attrs({ loading: "lazy" })`
  width: 32px;
  height: 32px;
  object-fit: cover;
  border-radius: 50%;
`;

const ChannelDescription = styled.div`
  flex: 1;
  margin: 0 8px;
  overflow: hidden;
`;

const ChannelLink = styled(Text)`
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  display: inline-block;
`;

interface Props {
  channel: AudiencableChannel;
  onRemove?: () => void;
}

const TestingAudienceChannelCard: FC<Props> = ({ channel, onRemove }) => {
  return (
    <ChannelCard key={channel.external_id}>
      <ThumbnailWrap>
        <YoutubeIcon />
        <Thumbnail src={channel.thumbnail} alt={channel.name} />
      </ThumbnailWrap>
      <ChannelDescription>
        <Text $type="smallHeadline">{channel.name}</Text>
        <ChannelLink
          href={`https://youtube.com/c/${channel.external_id}`}
          $type="extraSmall"
          $color="gray"
          as="a"
          target="_blank"
          rel="noreferrer noopener"
        >
          {`youtube.com/c/${channel.external_id}`}
        </ChannelLink>
      </ChannelDescription>
      {!!onRemove && (
        <Text
          as="button"
          $color="error"
          $type="smallHeadline"
          type="button"
          onClick={onRemove}
        >
          Remove
        </Text>
      )}
    </ChannelCard>
  );
};

export default TestingAudienceChannelCard;
